import { CommonModule, JsonPipe } from '@angular/common';
import { Component, ElementRef, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { DemoApiService } from './demo-api.service';
import { ListPage, PriorityStatus, TypeOfColumn } from 'design-system';
import { of } from 'rxjs';
import { MatChipsModule } from '@angular/material/chips';

export interface Animal {
  id: number;
  name: string;
}

export interface Food {
  value: string;
  viewValue: string;
}

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
  {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
];

@Component({
  selector: 'test-accessibility-testpage',
  imports: [
    ReactiveFormsModule, MatFormFieldModule,
    MatInputModule, MatAutocompleteModule,
    MatButtonModule, MatIconModule,
    MatBadgeModule, MatButtonToggleModule,
    MatCardModule, MatCheckboxModule,
    MatDatepickerModule, MatDialogModule,
    MatPaginatorModule, MatRadioModule,
    MatSelectModule, MatSlideToggleModule,
    MatTableModule, CommonModule,PriorityStatus, ListPage,
    MatChipsModule
],
  providers: [provideNativeDateAdapter()],
  templateUrl: './accessibility-testpage.html',
  styleUrl: './accessibility-testpage.css'
})
export class AccessibilityTestpage implements OnInit {

  // BADGE
  @Input() notifications = 0;
  @Input() messages = 45;

  readonly dialog = inject(MatDialog);

  @ViewChild('dialogTemplate') dialogTemplateRef!: TemplateRef<any>;
  @ViewChild('animalinput') animalInput: ElementRef<HTMLInputElement>;
  
  userProfileForm!: FormGroup;

  animalOptions: Animal[] = [
    {id: 1, name: 'Cane'}, {id: 2, name: 'Gatto'}, 
    {id: 3, name: 'Pinguino'}, {id: 4, name: 'Canguro'}
  ];
  filteredAnimalOptions: Animal[];

  foods: Food[] = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'},
  ];

  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSourceTable = ELEMENT_DATA;

  interceptorData: any;

  tasksArray: any[];

  constructor(
    private fb: FormBuilder,
    private api: DemoApiService
  ) {}

  ngOnInit(): void {
    this.userProfileForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      address: this.fb.group({
        street: [''],
        city: [''],
        zip: ['']
      }),
      animal: [''],
      phoneNumbers: this.fb.array([
        this.fb.control('')
      ])
    });

    // Example of task list
    this.tasksArray = TASK_DATA_EXAMPLE;
  }

  get phoneNumbers(): FormArray {
    return this.userProfileForm.get('phoneNumbers') as FormArray;
  }

  addPhoneNumber(): void {
    this.phoneNumbers.push(this.fb.control(''));
  }

  removePhoneNumber(index: number): void {
    this.phoneNumbers.removeAt(index);
  }
  
  onSubmit(): void {
    console.log("fomr value", this.userProfileForm.value  )
    console.log("fomr value raw", this.userProfileForm.getRawValue()  )
    if (this.userProfileForm.valid) {
      console.log('Form inviato!', this.userProfileForm.value);
      // API call
    } else {
      console.log('Form non valido!');
      this.userProfileForm.markAllAsTouched();
    }
  }

  toggleFormDisabled(): void {
    if (this.userProfileForm.disabled) {
      this.userProfileForm.enable();
    } else {
      this.userProfileForm.disable();
    }
  }

  displayFn(animal: Animal): string {
    return animal && animal.name ? animal.name : '';
  }


  filter() {
    const filterValue = this.animalInput.nativeElement.value.toLowerCase();
    console.log("filter", filterValue)
    this.filteredAnimalOptions = this.animalOptions.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  openDialog(): void {
    this.dialog.open(this.dialogTemplateRef, {
      ariaLabelledBy: 'dialog-title',
      ariaDescribedBy: 'dialog-content',
    });
  }

  //Test interceptors
  loadSuccess() {
    this.api.getSuccess().subscribe(response => {
      this.interceptorData = response;
      console.log("TEST 200", this.interceptorData);
      
    });
  }

  loadForbidden() {
    this.api.getForbidden().subscribe();
  }

  loadNotFound() {
    this.api.getNotFound().subscribe();
  }

  onClick() {
    console.log('click');
  }


  columnsInfo = [
    {
      columnNameDef: "titolo",
      label: "Titolo",
      type: TypeOfColumn.TEXT,
    },
    {
      columnNameDef: "nome",
      label: "Tipo Dettaglio",
      type: TypeOfColumn.TEXT,
    },
    {
      columnNameDef: "descrizione",
      label: "Descrizione",
      type: TypeOfColumn.TEXT,
    },
    {
      columnNameDef: "dataTask",
      label: "Data del task",
      type: TypeOfColumn.DATE,
    },
    {
      columnNameDef: "priority",
      label: "Priorità",
      type: TypeOfColumn.COMPONENT,
      component: PriorityStatus
    }
  ];

  dataSource = (pageSize?: number, pageNumber?: number, payload?: any) => {
    // TODO: Use correct API call!
    return of(this.tasksArray);
  }

  dataTransform = (data?: any) => {
    // let serverItems = data.items.map((item: any) => {
    //   return {
    //     ...item,
    //     details: '/details' + item.id
    //   };
    // });
    
    let totalRecords = data?.length;
    return { listData: data, totalItems: totalRecords };
  }

  debugField = new FormControl('', [
    control => control.value === 'error' ? { errorDebug: true } : null
  ]);
}


const TASK_DATA_EXAMPLE: any[] = [
  {
    id: "019a10b9-992b-717b-8d33-35483e76af5c",
    tipoDettaglio: "AutorizzazioneOrdini",
    titolo: "Prova 0",
    descrizione: "Autorizzazione di prova",
    priority: 0,
    primaryRole: {
      id: "019a10b9-9960-7ad3-b0be-8461ffd151e3",
      name: "AM",
      outcome: "",
      notes: "",
      ordinamento: null
    },
    roles: [
      {
        id: "019a10b9-999c-74d8-bd77-7c904f29792b",
        name: "FOV",
        outcome: "",
        notes: "",
        ordinamento: 1
      },
      {
        id: "019a10b9-9989-7ee4-b728-6804864ccb6d",
        name: "DP",
        outcome: "",
        notes: "",
        ordinamento: 2
      }
    ],
    dettaglio: null,
    taskSecurityMask: null,
    dataTask: "2025-04-10T22:00:00Z",
    importo: 140,
    prossimoApprovatore: "FOV",
    notaUtente: null,
    statoTask: 0
  },
  {
    id: "119a10b9-992b-717b-8d33-35483e76af5d",
    tipoDettaglio: "AutorizzazioneOrdini",
    titolo: "Prova 1",
    descrizione: "Autorizzazione di prova 1",
    priority: 1,
    primaryRole: {
      id: "119a10b9-9960-7ad3-b0be-8461ffd151e4",
      name: "AM",
      outcome: "",
      notes: "",
      ordinamento: null
    },
    roles: [
      {
        id: "019a10b9-999c-74d8-bd77-7c904f29792c",
        name: "FOV",
        outcome: "",
        notes: "",
        ordinamento: 1
      },
      {
        id: "019a10b9-9989-7ee4-b728-6804864ccb6e",
        name: "DP",
        outcome: "",
        notes: "",
        ordinamento: 2
      }
    ],
    dettaglio: null,
    taskSecurityMask: null,
    dataTask: null,
    importo: 155,
    prossimoApprovatore: "FOV",
    notaUtente: null,
    statoTask: 0
  },
  {
    id: "219a10b9-992b-717b-8d33-35483e76af5d",
    tipoDettaglio: "AutorizzazioneOrdini",
    titolo: "Prova 2",
    descrizione: "Autorizzazione di prova 2",
    priority: 2,
    primaryRole: {
      id: "219a10b9-9960-7ad3-b0be-8461ffd151e4",
      name: "AM",
      outcome: "",
      notes: "",
      ordinamento: null
    },
    roles: [
      {
        id: "019a10b9-999c-74d8-bd77-7c904f29792c",
        name: "FOV",
        outcome: "",
        notes: "",
        ordinamento: 1
      },
      {
        id: "019a10b9-9989-7ee4-b728-6804864ccb6e",
        name: "DP",
        outcome: "",
        notes: "",
        ordinamento: 2
      }
    ],
    dettaglio: null,
    taskSecurityMask: null,
    dataTask: "2025-04-11T10:00:00Z",
    importo: 155,
    prossimoApprovatore: "FOV",
    notaUtente: null,
    statoTask: 0
  },
    {
    id: "319a10b9-992b-717b-8d33-35483e76af5d",
    tipoDettaglio: "AutorizzazioneOrdini",
    titolo: "Prova 3",
    descrizione: "Autorizzazione di prova 3",
    priority: 3,
    primaryRole: {
      id: "319a10b9-9960-7ad3-b0be-8461ffd151e4",
      name: "AM",
      outcome: "",
      notes: "",
      ordinamento: null
    },
    roles: [
      {
        id: "019a10b9-999c-74d8-bd77-7c904f29792c",
        name: "FOV",
        outcome: "",
        notes: "",
        ordinamento: 1
      },
      {
        id: "019a10b9-9989-7ee4-b728-6804864ccb6e",
        name: "DP",
        outcome: "",
        notes: "",
        ordinamento: 2
      }
    ],
    dettaglio: null,
    taskSecurityMask: null,
    dataTask: "2025-04-11T10:00:00Z",
    importo: 155,
    prossimoApprovatore: "FOV",
    notaUtente: null,
    statoTask: 0
  },
  {
    id: "019a10b9-992b-717b-8d33-35483e76af5c",
    tipoDettaglio: "AutorizzazioneOrdini",
    titolo: "Prova 0",
    descrizione: "Autorizzazione di prova",
    priority: 0,
    primaryRole: {
      id: "019a10b9-9960-7ad3-b0be-8461ffd151e3",
      name: "AM",
      outcome: "",
      notes: "",
      ordinamento: null
    },
    roles: [
      {
        id: "019a10b9-999c-74d8-bd77-7c904f29792b",
        name: "FOV",
        outcome: "",
        notes: "",
        ordinamento: 1
      },
      {
        id: "019a10b9-9989-7ee4-b728-6804864ccb6d",
        name: "DP",
        outcome: "",
        notes: "",
        ordinamento: 2
      }
    ],
    dettaglio: null,
    taskSecurityMask: null,
    dataTask: "2025-04-10T22:00:00Z",
    importo: 140,
    prossimoApprovatore: "FOV",
    notaUtente: null,
    statoTask: 0
  },
  {
    id: "119a10b9-992b-717b-8d33-35483e76af5d",
    tipoDettaglio: "AutorizzazioneOrdini",
    titolo: "Prova 1",
    descrizione: "Autorizzazione di prova 1",
    priority: 1,
    primaryRole: {
      id: "119a10b9-9960-7ad3-b0be-8461ffd151e4",
      name: "AM",
      outcome: "",
      notes: "",
      ordinamento: null
    },
    roles: [
      {
        id: "019a10b9-999c-74d8-bd77-7c904f29792c",
        name: "FOV",
        outcome: "",
        notes: "",
        ordinamento: 1
      },
      {
        id: "019a10b9-9989-7ee4-b728-6804864ccb6e",
        name: "DP",
        outcome: "",
        notes: "",
        ordinamento: 2
      }
    ],
    dettaglio: null,
    taskSecurityMask: null,
    dataTask: null,
    importo: 155,
    prossimoApprovatore: "FOV",
    notaUtente: null,
    statoTask: 0
  },
  {
    id: "219a10b9-992b-717b-8d33-35483e76af5d",
    tipoDettaglio: "AutorizzazioneOrdini",
    titolo: "Prova 2",
    descrizione: "Autorizzazione di prova 2",
    priority: 2,
    primaryRole: {
      id: "219a10b9-9960-7ad3-b0be-8461ffd151e4",
      name: "AM",
      outcome: "",
      notes: "",
      ordinamento: null
    },
    roles: [
      {
        id: "019a10b9-999c-74d8-bd77-7c904f29792c",
        name: "FOV",
        outcome: "",
        notes: "",
        ordinamento: 1
      },
      {
        id: "019a10b9-9989-7ee4-b728-6804864ccb6e",
        name: "DP",
        outcome: "",
        notes: "",
        ordinamento: 2
      }
    ],
    dettaglio: null,
    taskSecurityMask: null,
    dataTask: "2025-04-11T10:00:00Z",
    importo: 155,
    prossimoApprovatore: "FOV",
    notaUtente: null,
    statoTask: 0
  },
];